import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { AppState } from 'services/types';
// @ts-ignore
import { setCurrentNumberOfDays } from 'services/currentNumberOfDays/actions';
// @ts-ignore
import { selectCurrentNumberOfDays } from 'services/currentNumberOfDays/selectors';

interface OwnProps {
    fullScreen?: boolean;
    text: string;
    value: number;
}

interface ConnectedProps {
    currentNumberOfDays?: ReturnType<typeof setCurrentNumberOfDays>;
}

interface DispatchProps {
    setCurrentNumberOfDays: typeof setCurrentNumberOfDays;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class NumberOfDaysDropdownItemComponent extends React.Component<Props> {
    // HACK should not be handled in this component
    componentDidMount(): void {
        const { currentNumberOfDays, fullScreen, ...props } = this.props;
        if (!currentNumberOfDays) {
            const numberOfDays = fullScreen ? 1 : 7;
            props.setCurrentNumberOfDays(numberOfDays);
        }
    }

    handleClick = (): void => {
        const { value } = this.props;
        this.props.setCurrentNumberOfDays(value);
    };

    render(): React.ReactElement {
        const { text, value, currentNumberOfDays } = this.props;
        const active = value === currentNumberOfDays;
        return (
            <Dropdown.Item
                text={text}
                onClick={this.handleClick}
                active={active}
                selected={active}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    currentNumberOfDays: selectCurrentNumberOfDays
});

export default withMobileDialog()(
    connect(mapStateToProps, { setCurrentNumberOfDays })(
        NumberOfDaysDropdownItemComponent
    )
);
